//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from "vuex";
import SearchFilterTagsItem from './SearchFiltersTagsItem.vue'
export default {
	name: 'SearchFilterTags',
	components: {
		SearchFilterTagsItem
	},
	computed: {
		...mapGetters(["searchQuery", "results"]),
		selectedFilters() {
			return this.results.filters.reduce((selectedFilters, filterGroup) => {
				let groupID = filterGroup.id;
				let selectedInGroup = filterGroup.filters.filter(filter => filter.selected).map(selectedFilter => {
					return {...selectedFilter, groupID}
				});
				selectedFilters = [...selectedFilters, ...selectedInGroup];
				return selectedFilters;
			}, []);
		}
	},
	methods: {
    ...mapMutations(['setFilterItem']),
		submitFilters(data) {
			this.setFilterItem(data);
			this.$emit("submitfilters", this.getFilterQuerystring());
		},
		shouldTagsBeShown() {
			return this.selectedFilters.length > 0;
		},
		getFilterQuerystring() {
			const ids = [];
			this.searchQuery.filters.forEach((parent) => {
				const group = parent.filters
					.filter((c) => c.selected == true)
					.map((a) => a.id);

				if (group.length > 0) {
					ids.push(group);
				}
			});
			return ids.join(",");
		},
		clearAll() {
			this.selectedFilters.forEach(item => {
				const data = {
					groupID: item.groupID,
					id: item.id,
					value: false
				};
				this.setFilterItem(data);
			});
			this.$emit("submitfilters", this.getFilterQuerystring());
		}
	}
}
